(function () {
  'use strict';

  var FALLBACK_VARIANT_IDS = {
    single: 49839197126896,
    double: 49839570682096,
    family: 49839570714864
  };

  var selectedBundleType = 'double';
  var MISSING_VARIANT_MSG = 'Variant ID missing. Link the bundle product in the theme editor.';

  function getConfig() {
    return window.FPV_CONFIG || {};
  }

  function getBundleSection() {
    return document.querySelector('[data-bundle-section]');
  }

  function getVariantMap() {
    var section = getBundleSection();
    if (!section) return {};
    try {
      return JSON.parse(section.getAttribute('data-variants') || '{}');
    } catch (error) {
      console.error('[FPV] Invalid data-variants JSON:', error);
      return {};
    }
  }

  function parseVariantId(value) {
    if (value == null || value === '') return null;
    var id = typeof value === 'number' ? value : parseInt(String(value), 10);
    return isNaN(id) || id <= 0 ? null : id;
  }

  function getVariantId(bundleKey) {
    var variants = getVariantMap();
    var mappedId = parseVariantId(variants[bundleKey]);
    if (mappedId) return mappedId;

    var card = document.querySelector('[data-bundle-card][data-bundle="' + bundleKey + '"]');
    if (card) {
      var cardId = parseVariantId(card.getAttribute('data-variant-id'));
      if (cardId) return cardId;
    }

    return parseVariantId(FALLBACK_VARIANT_IDS[bundleKey]);
  }

  function readBundleCard(bundleKey) {
    var card = document.querySelector('[data-bundle-card][data-bundle="' + bundleKey + '"]');
    if (!card) return null;
    return {
      name: card.getAttribute('data-bundle-name') || '',
      price: card.getAttribute('data-bundle-price') || '',
      save: card.getAttribute('data-bundle-save') || ''
    };
  }

  function updateMainBundleCta(bundleKey) {
    var bundle = readBundleCard(bundleKey);
    var labelEl = document.getElementById('fpv-main-bundle-cta-label');
    var ctaEl = document.getElementById('fpv-main-bundle-cta');
    if (!bundle || !labelEl) return;
    labelEl.textContent = 'Add ' + bundle.name + ' to Cart';
    if (ctaEl && bundle.price) {
      ctaEl.setAttribute('aria-label', 'Add ' + bundle.name + ' (' + bundle.price + ') to cart');
    }
  }

  function selectBundle(element, bundleKey) {
    document.querySelectorAll('[data-bundle-card]').forEach(function (card) {
      card.classList.remove('selected');
      card.setAttribute('aria-pressed', 'false');
    });
    if (element) {
      element.classList.add('selected');
      element.setAttribute('aria-pressed', 'true');
    }
    selectedBundleType = bundleKey;
    updateStickyBar(bundleKey);
    updateMainBundleCta(bundleKey);
  }

  function initBundleCards() {
    var section = getBundleSection();
    if (!section || section.dataset.bundleCardsInit === 'true') return;
    section.dataset.bundleCardsInit = 'true';

    section.addEventListener('click', function (event) {
      var card = event.target.closest('[data-bundle-card]');
      if (!card || !section.contains(card)) return;
      var bundleKey = card.getAttribute('data-bundle');
      if (bundleKey) selectBundle(card, bundleKey);
    });

    section.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var card = event.target.closest('[data-bundle-card]');
      if (!card || !section.contains(card)) return;
      event.preventDefault();
      var bundleKey = card.getAttribute('data-bundle');
      if (bundleKey) selectBundle(card, bundleKey);
    });
  }

  function updateStickyBar(bundleKey) {
    var bundle = readBundleCard(bundleKey);
    var nameEl = document.getElementById('sticky-bundle-name');
    var priceEl = document.getElementById('sticky-bundle-price');
    var saveEl = document.getElementById('sticky-save-text');
    if (!bundle || !nameEl || !priceEl || !saveEl) return;
    nameEl.textContent = bundle.name;
    priceEl.textContent = bundle.price;
    saveEl.textContent = bundle.save || '';
  }

  function showCartToast() {
    var existing = document.getElementById('fpv-cart-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.id = 'fpv-cart-toast';
    toast.className = 'fixed bottom-6 left-1/2 -translate-x-1/2 bg-[#22c55e] text-white px-8 py-3 rounded-2xl flex items-center gap-x-3 shadow-xl z-[200]';
    toast.innerHTML = '<i class="fa-solid fa-check"></i><span class="font-semibold">Added to cart! Redirecting...</span>';
    document.body.appendChild(toast);
  }

  function addVariantToCart(variantId) {
    var cartAddUrl = getConfig().cartAddUrl || '/cart/add.js';

    return fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ id: variantId, quantity: 1 })
    }).then(function (response) {
      return response.text().then(function (text) {
        var data = null;
        try { data = text ? JSON.parse(text) : null; } catch (e) { data = null; }
        if (!response.ok) {
          throw new Error((data && (data.description || data.message)) || ('Cart error ' + response.status));
        }
        return data;
      });
    });
  }

  function addToCart(bundleKey) {
    console.log('Selected bundle:', bundleKey);

    var variantId = getVariantId(bundleKey);
    console.log('Variant ID:', variantId);

    if (!variantId) {
      alert(MISSING_VARIANT_MSG);
      return;
    }

    selectedBundleType = bundleKey;
    var card = document.querySelector('[data-bundle-card][data-bundle="' + bundleKey + '"]');
    if (card) selectBundle(card, bundleKey);

    addVariantToCart(variantId)
      .then(function () {
        updateCartCount();
        showCartToast();
        setTimeout(function () {
          window.location.href = getConfig().cartUrl || '/cart';
        }, 1200);
      })
      .catch(function (error) {
        console.error('[FPV] add to cart failed:', error);
        alert(error.message || 'Could not add to cart.');
      });
  }

  function addSelectedBundleToCart() {
    addToCart(selectedBundleType);
  }

  function addSelectedToCart() {
    addSelectedBundleToCart();
  }

  function toggleFAQ(element) {
    var answer = element.nextElementSibling;
    if (!answer) return;
    var isOpen = answer.classList.toggle('hidden') === false;
    var item = element.closest('[data-fpv-faq-item]');
    if (item) item.classList.toggle('is-open', isOpen);
    element.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }

  function initFAQShowMore() {
    document.querySelectorAll('[data-fpv-faq-show-more]').forEach(function (button) {
      if (button.dataset.fpvFaqBound === 'true') return;
      button.dataset.fpvFaqBound = 'true';

      var list = button.closest('.fpv-faq-inner');
      list = list ? list.querySelector('[data-fpv-faq-list]') : null;
      if (!list) return;

      var showMoreLabel = button.querySelector('[data-fpv-faq-show-more-label]');
      var showMoreText = button.getAttribute('data-show-more') || 'View all questions';
      var showLessText = button.getAttribute('data-show-less') || 'Show fewer questions';

      button.addEventListener('click', function () {
        var expanded = list.classList.toggle('is-expanded');
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        if (showMoreLabel) {
          showMoreLabel.textContent = expanded ? showLessText : showMoreText;
        }
      });
    });
  }

  function updateCartCount() {
    var countEl = document.getElementById('cart-count');
    if (!countEl) return;
    fetch(getConfig().cartJsUrl || '/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { countEl.textContent = cart.item_count; })
      .catch(function () {});
  }

  function scrollToBundles() {
    var target = document.getElementById('bundles') || document.getElementById('choose-your-bundle');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function startCountdown() {
    var timerRoot = document.getElementById('launch-offer-timer');
    if (!timerRoot) return;

    var textEl = document.getElementById('launch-offer-timer-text');
    if (!textEl) return;

    var minutes = parseInt(timerRoot.getAttribute('data-minutes') || '10', 10);
    if (isNaN(minutes) || minutes < 1) minutes = 10;

    var cycleMs = minutes * 60 * 1000;
    var cycleSeconds = minutes * 60 - 1;

    if (window.__fpvCountdownInterval) {
      clearInterval(window.__fpvCountdownInterval);
    }

    function tick() {
      var position = Date.now() % cycleMs;
      var secondsLeft = cycleSeconds - Math.floor(position / 1000);
      if (secondsLeft <= 0) secondsLeft = cycleSeconds;

      var m = Math.floor(secondsLeft / 60);
      var s = secondsLeft % 60;
      textEl.textContent =
        '🔥 Limited Time Offer ' +
        String(m).padStart(2, '0') + ':' +
        String(s).padStart(2, '0');
    }

    tick();
    window.__fpvCountdownInterval = setInterval(tick, 1000);
  }

  function initMobileMenu() {
    var menu = document.getElementById('velora-mobile-menu');
    var openBtn = document.querySelector('[data-velora-menu-open]');
    if (!menu || !openBtn) return;

    function setOpen(isOpen) {
      menu.hidden = !isOpen;
      openBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      document.body.classList.toggle('velora-menu-open', isOpen);
    }

    openBtn.addEventListener('click', function () {
      setOpen(true);
    });

    menu.querySelectorAll('[data-velora-menu-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        setOpen(false);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !menu.hidden) setOpen(false);
    });
  }

  function initFpvHeroVideo() {
    var video = document.querySelector('[data-fpv-hero-video]');
    if (!video) return;

    var fallback = document.querySelector('[data-fpv-hero-fallback]');
    var wrap = video.closest('.fpv-hero-image-wrap');

    function showFallback() {
      video.classList.add('is-hidden');
      if (wrap) wrap.classList.remove('fpv-hero-image-wrap--video');
      if (fallback) fallback.hidden = false;
    }

    video.addEventListener('error', showFallback);
    video.addEventListener('stalled', function () {
      if (video.error) showFallback();
    });

    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {
        if (video.error) showFallback();
      });
    }
  }

  function initFpvSeeDriverSection() {
    var section = document.querySelector('[data-fpv-see-driver]');
    if (!section) return;

    var video = section.querySelector('[data-fpv-driver-video]');
    var fallback = section.querySelector('[data-fpv-driver-fallback]');
    if (!video) return;

    function showFallback() {
      video.classList.add('is-hidden');
      if (fallback) fallback.hidden = false;
    }

    function playVideo() {
      video.preload = 'auto';
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          if (video.error) showFallback();
        });
      }
    }

    function pauseVideo() {
      if (!video.paused) video.pause();
    }

    video.addEventListener('error', showFallback);
    video.addEventListener('stalled', function () {
      if (video.error) showFallback();
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              playVideo();
            } else {
              pauseVideo();
            }
          });
        },
        { threshold: 0.25, rootMargin: '0px 0px -5% 0px' }
      );
      observer.observe(section);
    } else {
      playVideo();
    }
  }

  function initialize() {
    initMobileMenu();
    initBundleCards();
    initFpvHeroVideo();
    initFpvSeeDriverSection();
    var highlight = document.querySelector('[data-bundle-card].selected') ||
      document.querySelector('[data-bundle-card][data-bundle="double"]');
    if (highlight) {
      selectBundle(highlight, highlight.getAttribute('data-bundle') || 'double');
    }
    updateCartCount();
    startCountdown();
    updateStickyBar(selectedBundleType);
    initFAQShowMore();

    var stickyBar = document.getElementById('sticky-add-bar');
    if (stickyBar) {
      window.addEventListener('scroll', function () {
        if (window.scrollY > 600) stickyBar.classList.remove('hidden');
        else stickyBar.classList.add('hidden');
      });
    }
  }

  window.selectBundle = selectBundle;
  window.addToCart = addToCart;
  window.addSelectedBundleToCart = addSelectedBundleToCart;
  window.addSelectedToCart = addSelectedToCart;
  window.toggleFAQ = toggleFAQ;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', initialize);
})();
